<template>
	<div>
		<el-drawer title="直播商品" :visible.sync="drawer" wrapperClosable size="674px">
			<div class="pl-24 pr-24 pt-24">
				<div class="pb-24 title flex flex-just-between">
					<div class="title-left">
						<div :class="['flex flex-align-center up fz-14 pointer', !ind ? 'disable' : '']" @click="upFun">
							<i class="el-icon-d-arrow-left"></i>
							<p class="ml-6">上一场</p>
						</div>
					</div>
					<div class="title-middle flex flex-align-center">
						<p class="yx-color-text-primary font-bold ml-6 yx-color-text-primary">
							<span>{{ anchor_info.live_type === '1' ? '预计开播时间：' : '开播时间：' }}</span>
							<span>{{ anchor_info.live_type === '1' ? anchor_info.estimate_time : anchor_info.cooperate_start_time }}</span>
						</p>
						<div :class="['time-right fz-12 ml-10', anchor_info.live_type === '2' ? 'started' : 'not-start']">
							{{ anchor_info.live_type === '2' ? '已开播' : '未开播' }}
						</div>
					</div>
					<div class="title-right flex flex-align-center fz-14">
						<div :class="['flex flex-align-center next fz-14 pointer', length === ind + 1 ? 'disable' : '']" @click="nextFun">
							<p class="mr-6">下一场</p>
							<i class="el-icon-d-arrow-right"></i>
						</div>
					</div>
				</div>
				<div class="info flex flex-align-center flex-just-between">
					<div class="info-left flex">
						<yx-avatar :size="60" :src="anchor_info.head"></yx-avatar>
						<div class="info-title ml-10" v-if="anchor_info.anchor_id != 0">
							<div class="flex flex-align-center">
								<platform-icon :platformId="anchor_info.platform_id"></platform-icon>
								<p class="ml-6 fz-14">{{ anchor_info.anchor_name }}</p>
							</div>
							<div class="fan-box mt-4 fz-12" v-if="anchor_info.fans_num != -1">粉丝量：{{ anchor_info.fans_num }}</div>
							<div class="fz-12 mt-4 yx-color-text-regular">{{ anchor_info.platform_id | formatPlatformName }}：{{ anchorAccount }}</div>
						</div>
						<div class="fz-12 mt-4 yx-color-text-regular flex flex-align-center ml-10" v-else>无关联达人</div>
					</div>
					<div
						v-if="anchor_info.anchor_id != 0"
						class="info-right yx-color-text-regular fz-14 pointer"
						@click="showDetailDrawer(anchor_info.anchor_id)"
					>
						查看达人详情
					</div>
				</div>
				<div class="total font-bold fz-14 yx-color-text-primary mt-24 mb-16">
					共
					<span>{{ gridData.length }}</span>
					件商品
				</div>
				<el-table :data="gridData" header-row-class-name="table-header-row" row-class-name="table-row">
					<el-table-column label="商品信息" min-width="150" align="center">
						<template slot-scope="{ row }">
							<div class="flex flex-align-center">
								<img class="shop_img" :src="row.product_pic" alt="" />
								<div class="box ml-10 PingFang yx-color-text-primary fz-13">
									<div class="flex shop-box">
										<el-tooltip :content="row.product_name" effect="dark" placement="top">
											<p class="product_name">{{ row.product_name }}</p>
										</el-tooltip>
										<el-tooltip class="item" effect="dark" placement="top">
											<div slot="content" class="content">
												<span>商品ID</span>
												<span class="ml-10">{{ row.third_product_id }}</span>
												<img src="@/assets/public/copy-icon.png" alt="" @click="copy(row.third_product_id)" />
											</div>
											<p class="ID-sign yx-color-text-regular">ID</p>
										</el-tooltip>
									</div>
									<p class="flex flex-align-center yx-color-text-primary">
										<span>直播价：</span>
										<span>¥{{ row.live_price }}</span>
									</p>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="达人佣金率" min-width="100">
						<template slot-scope="{ row }">
							<p>{{ row.commission_rate + '%' }}</p>
						</template>
					</el-table-column>
					<el-table-column label="团长服务费率" min-width="100" v-if="$auth.hasPermi('system:goods-ServiceRate')">
						<template slot-scope="{ row }">
							<p>{{ row.service_rate + '%' }}</p>
						</template>
					</el-table-column>
					<el-table-column property="opear" label="操作">
						<template slot-scope="{ row }">
							<div>
								<span class="btn yx-color-primary" @click="skipFun(row)">查看合作进度</span>
							</div>
						</template>
					</el-table-column>
					<template slot="empty">
						<span class="yx-color-text-primary fz-14">暂无数据</span>
					</template>
				</el-table>
			</div>
			<div class="footer mt-20">
				<el-button type="primary" @click="drawer = false">知道了</el-button>
			</div>
		</el-drawer>
		<detail-drawer ref="detailDrawer" />
	</div>
</template>
<script>
import detailDrawer from '@/views/talentCRM/components/detailDrawer';
export default {
	components: {
		detailDrawer,
	},
	data() {
		return {
			drawer: false,
			gridData: [],
			row: {},
			avatarUrl: '',
			anchor_info: {},
			detail_list: [],
			ind: 0,
			length: 0,
		};
	},
	computed: {
		anchorAccount() {
			const temPF = {
				[dataMap.PLATFORM_DY.value]: this.anchor_info.anchor_account,
				[dataMap.PLATFORM_KS.value]: this.anchor_info.anchor_account,
				[dataMap.PLATFORM_SP.value]: this.anchor_info.anchor_uid,
			};
			return temPF[this.anchor_info.platform_id];
		},
	},
	methods: {
		async show(list, obj, arr, ind) {
			this.ind = ind;
			this.detail_list = arr;
			this.anchor_info = obj;
			this.gridData = list;
			this.length = this.detail_list.length;
			this.drawer = true;
		},
		addFun(row) {
			this.$refs.addContact.show(row.open_id, '1');
		},
		copy(value) {
			var inputTest = document.createElement('textarea');
			inputTest.value = value;
			document.body.appendChild(inputTest);
			inputTest.select();
			document.execCommand('Copy');
			inputTest.className = 'oInput';
			inputTest.style.display = 'none';
			this.$message.success('复制成功');
			document.body.removeChild(inputTest);
		},
		skipFun({ cooperate_id, status = '0' }) {
			if (!this.$auth.hasPermi('system:cooperationProgress-query')) {
				this.$message.warning('暂无合作进度页面权限');
				return;
			}
			const routeLink = this.$router.resolve({
				path: '/cooperationProgress/list',
				query: {
					cooperate_id: cooperate_id,
					tabid: String(Number(status) - 1),
				},
			});
			window.open(routeLink.href, '_blank');
		},
		getList() {
			this.getViewList();
		},
		showDetailDrawer(anchor_id) {
			this.$refs.detailDrawer.show(anchor_id);
		},
		upFun() {
			if (!this.ind) {
				return;
			} else {
				this.ind--;
			}
			this.anchor_info = this.detail_list[this.ind].anchor_info;
			this.gridData = this.detail_list[this.ind].product_list;
		},
		nextFun() {
			if (this.length > this.ind + 1) {
				this.ind++;
			} else {
				return;
			}
			this.anchor_info = this.detail_list[this.ind].anchor_info;
			this.gridData = this.detail_list[this.ind].product_list;
		},
	},
};
</script>
<style lang="less" scoped>
.tips {
	padding: 10px 24px;
	p {
		padding: 10px;
		background: #e9f1ff;
		border: 1px solid #bdd5ff;
		border-radius: 2px;
	}
}
.crm-xs {
	cursor: pointer;
}
.btn {
	cursor: pointer;
}
.product_name {
	width: 120px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.shop_img {
	width: 40px;
	height: 40px;
	border-radius: 5px;
}
.shop-box {
	width: 200px;
}
.started {
	color: #0fb820;
	border: 1px solid #0fb820;
}
.not-start {
	color: #fa8f14;
	border: 1px solid #fa8f14;
}
.info-title {
	height: 60px;
}
.ID-sign {
	padding: 2px 4px;
	border-radius: 2px;
	background-color: #f8f8f8;
	cursor: pointer;
}
.ID-sign:hover {
	color: @color-primary;
}
.content {
	display: flex;
	align-items: center;
	img {
		margin-left: 8px;
		width: 16px;
		height: 16px;
		cursor: pointer;
	}
}
.info {
	padding: 16px;
	border: 1px solid #eeeeee;
}
.fan-box {
	display: inline-block;
	border-radius: 2px;
	padding: 2px 4px;
	color: #fa8f14;
	background-color: #fef3e7;
}
.time-right {
	padding: 1px 4px;
	border-radius: 4px;
}
.info-right:hover {
	color: @color-primary;
}
.footer {
	width: 100%;
	position: absolute;
	left: 0;
	bottom: 0;
	display: flex;
	justify-content: flex-end;
	padding: 16px 12px;
	border-top: 1px solid #eeeeee;
}
.up:hover,
.next:hover {
	color: @color-primary;
}
.disable {
	color: #ccc;
}
.disable:hover {
	color: #ccc;
	cursor: default;
}
</style>
